import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, vendorDataAtom } from '../vendor_list_atoms';
import { VendorDataHook } from '../vendor_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useVendorData = (): VendorDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(vendorDataAtom);

    const { items } = useTableData({ view, filters, stats, data, setStats });

    return { items };
};
